import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-static';
import { getRelativeUrl } from '@flow/utils/cleaners.js';
import em from 'polished/lib/helpers/em';
import Moment from 'react-moment';

const ListItemContent = styled.div`
  a {
    position: relative;
    text-decoration: none;
    display: block;
    padding: 3em 15.6em;
    color: black;
    border-bottom: .1em solid ${props => props.theme.highlightColor}; 
    
    &:${props => props.theme.hoverProperty},
    &.active {
      background-color: ${props => props.theme.highlightColor};
      border-color: black;
    }
  }
  
  &.no-border {
    a {
      padding-left: 3em;
      padding-right: 3em;
    }
  }
`;

const ListItemTime = styled.div`
  display: block;
  text-transform: uppercase;
  font-size: 1.6em;
  font-family: Flow-Poster-Bold;
`;

const ListItemTitle = styled.span`
  display: block;
  font-size: 2.1em;
  line-height: ${em(2.8, 2.1)};
  margin-top: ${em(1.5, 2.1)};
`;

class ListItem extends React.Component {
  render() {
    const {
      appLanguage,
      post: {
        title,
        date,
        link,
      },
      noBorder,
    } = this.props;

    return (
      <ListItemContent className={noBorder ? 'no-border' : null}>
        <NavLink to={getRelativeUrl(link)} activeClassName='active'>
          <ListItemTime>
            <Moment locale={appLanguage.code} date={date} format={'MMM Do YYYY'}/>
          </ListItemTime>
          <ListItemTitle>
            { title }
          </ListItemTitle>
        </NavLink>
      </ListItemContent>
    );
  }
}

export default ListItem;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/news/components/ListItem.tsx